module.exports = __webpack_public_path__ + "static/oracle-logo-33b2d8b8f036486f2d7ce8c84a9edf5f.png";